import React from 'react';
import NavbarMulti from "../../../../../../components/Navbar/NavbarMulti";
import {ConfigApi} from "../../../../../../services/Api/types";
import FetchPlaces from "../../../../../../components/Fetch/FetchPlaces";
import {usePlaceContext} from "../../../../../../services/Place/PlaceContext";
import MultistorePlaceCard from "../PlaceCard/MultistorePlaceCard";
import Footer from "../../../../../../components/layout/Footer/Footer";
import {getLanguagesBasedOnStoreType} from "../../../../../../services/languageUtils";
import MultistoreBrandListHero from "./Hero/MultistoreBrandListHero";

interface Props {
    config: ConfigApi;
}

const MultistoreBrandListHomePage = ({config}: Props) => {
    const {places} = usePlaceContext();
    const availablePlaces = (places || []).filter(place => place.status === "ACTIVE" || place.status === "PAUSED");

    return (
        <div className="multistore-brand-list-home-page">
            <NavbarMulti config={config}/>
            <div className="inner-container">
                <MultistoreBrandListHero config={config} places={availablePlaces}/>
                <div className="sections">
                    <div className="places" id="places">
                        <FetchPlaces>
                            {(availablePlaces).map(place => (
                                <MultistorePlaceCard place={place} key={place.domain}/>
                            ))}
                        </FetchPlaces>
                    </div>
                    <Footer config={config} languages={getLanguagesBasedOnStoreType(config)}/>
                </div>
            </div>
        </div>
    )
}

export default MultistoreBrandListHomePage;